import axios from 'axios';

export default {
    baseUrl : '/api/admin/agent/',

    getLogin: function(params) {
        return axios.post(this.baseUrl + 'login',  params);
    },
    getRechargeDaily: function(params) {
        return axios.post(this.baseUrl + 'rechargeDaily',  params);
    },
    getRechargeCollect: function(params) {
        return axios.post(this.baseUrl + 'rechargeCollect',  params);
    },
}
